(function () {
  const drawer = document.getElementById('amg-filter-drawer');
  if (!drawer) return;

  const overlay = document.querySelector('.amg--drawer-overlay');
  const isDesktop = () => window.matchMedia('(min-width: 860px)').matches;

  function openDrawer(e) {
    if (e) { e.preventDefault(); }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('amg--drawer-open');
    overlay.hidden = false;

    const focusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
  }

  function closeDrawer(e) {
    if (e) e.preventDefault();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('amg--drawer-open');
    overlay.hidden = true;
  }

  // CAPTURING interceptor: blocks Empire's mobile modal on DESKTOP only
  function intercept(e) {
    const trigger = e.target.closest('[data-productgrid-trigger-filters]');
    if (!trigger || !isDesktop()) return;
    // Kill the event before it reaches Empire's listeners
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    openDrawer(e);
  }

  // Intercept early on both pointer and click to be extra safe
  ['pointerdown', 'click'].forEach(evt => {
    document.addEventListener(evt, intercept, true); // <-- capture phase
  });

  // Close handlers (bubbling is fine here)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.amg--drawer-close')) return closeDrawer(e);
    if (e.target === overlay) return closeDrawer(e);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(e);
  });
})();
